import React from 'react'

import { cn } from './ui/cn'

interface HeroProps {
  className?: string
  imgUrl?: string
  size?: 'small' | 'default' | 'full'
  children?: React.ReactNode
}

/**
 * Ship&Play hero band. Matches playground `Hero` exactly — `size` picks one
 * of three min-heights (small = 320px, default = 640px, full = viewport
 * minus the fixed nav bar height).
 */
export const Hero = ({
  className,
  children,
  imgUrl,
  size = 'default',
}: HeroProps): React.ReactElement => {
  return (
    <section
      className={cn(
        'snplay:-mt-20 snplay:flex snplay:items-center snplay:justify-center',
        'snplay:bg-cover snplay:bg-center snplay:bg-no-repeat snplay:pt-20',
        size === 'small' && 'snplay:min-h-80',
        size === 'default' && 'snplay:min-h-160',
        size === 'full' && 'snplay:min-h-[calc(100vh-3rem)]',
        className,
      )}
      style={imgUrl ? { backgroundImage: `url(${imgUrl})` } : undefined}
    >
      <div
        className={cn(
          'snplay-bounds snplay:flex-1 snplay:py-10',
          'snplay:xs:grid snplay:xs:grid-cols-12 snplay:xs:gap-8',
        )}
      >
        {children}
      </div>
    </section>
  )
}
